import React, { useCallback } from 'react';
import { IResource, useDispatch, useSelector } from '~/redux';

import ResourceOutputModal from '~/components/modals/ResourceOutputModal';
import content from '~/utils/contentAPI';

import { openModal } from '~/redux/actions';
import ResourceItemModeList from './ResourceItemModeList';
import ResourceItemModeGrid from './ResourceItemModeGrid';
import TrainingModuleModal from '~/components/modals/TrainingModuleModal';

import { getModuleByKey }from '~/utils/trainingModules';

import config from '~/config';

interface ResourceItemProps {
  resource: IResource;
  index: number;
  mode: 'list' | 'grid';
}
const ResourceItem: React.FC<ResourceItemProps> = ({ resource, mode }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const thumbnailURL =  resource?.thumbnail?.url ? 
    (content.getContentURL() + resource.thumbnail.url) : '';
  const thumbnailBgStyle = !!thumbnailURL ? {
    backgroundImage: 'url(' + thumbnailURL + ')',
  } : {};

  const openResourceModal = useCallback((res) => {
    if (res.type === 'Training') {
      const module = getModuleByKey(res.training_module_key);

      if (module) {
        let parsedBaseURL = module.path;
        if (module.pathMode === 'absolute') {
          parsedBaseURL = window.location.protocol + '//' + window.location.host + parsedBaseURL;
        }

        const url = parsedBaseURL + '?sid=' + user?.uid + '&cmid=' + module.cmid;
        if (config.debug) { console.log('load training module', config.modules, url, <TrainingModuleModal config={{ url }} />) }

        dispatch(openModal({
          content: <TrainingModuleModal config={{ url }} />,
          mode: 'fullscreen'
        }));
      }

    } else {
      dispatch(openModal({
        content: <ResourceOutputModal config={res} />,
        mode: resource.type === 'Link' ? 'minimal' : 'normal'
      }));
    }
    
  }, [dispatch, resource]);

  const displayProps = { 
    resource, thumbnailBgStyle,
    openResourceModal 
  };

  return (
    mode === 'list' || window.innerWidth < 768 ? 
      <ResourceItemModeList  {...displayProps} /> :
      <ResourceItemModeGrid  {...displayProps} />
  )
}

export default ResourceItem;

export interface ResourceItemModeProps {
  resource: IResource;
  thumbnailBgStyle: object;
  openResourceModal: (res: IResource) => void;
}


// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourceItem.tsx